import { FeedbackModal } from "@/components/feedback"
import { Text } from "@/components/ui"
import { getOrderProgressSummary } from "@/lib/order-status"
import { OrderResponse } from "@/types/external"

export default function DuplicateOrderWarningModal({
  open,
  onOpenChange,
  activeOrder,
  onConfirm,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  activeOrder: OrderResponse
  onConfirm: () => void
}) {
  const { label: statusLabel } = getOrderProgressSummary(activeOrder)

  return (
    <FeedbackModal
      open={open}
      onOpenChange={onOpenChange}
      variant="warning"
      title="Pedido em andamento"
      description={
        <p>
          Seu pedido anterior ainda está{" "}
          <Text as="strong" weight="bold" tone="default">{statusLabel.toLowerCase()}</Text>.
          Quer fazer um novo pedido mesmo assim?
        </p>
      }
      confirmLabel="Fazer novo pedido"
      onConfirm={onConfirm}
      cancelLabel="Voltar"
    />
  )
}
